import { COLORS } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

import { Card, CardHeader } from "../../common/Card";
import { NewWindow, Source } from "../../common/Icons";

const StyledPanel = styled.div`
  padding: 10px;

  .anticon {
    &.anticon-down,
    &.anticon-up {
      line-height: 2;
    }
  }

  .ant-radio-wrapper {
    margin: 5px 3px;
    font-weight: 500;airtable_fe_review_fixes
    color: ${COLORS.black85};

    &.ant-radio-wrapper-checked {
      color: ${COLORS.coeblue4};
    }
  }
`;

const StyledList = styled.ul`
  list-style: none;
  margin: 0px auto;
  padding: 0px;

  li {
    margin: 8px 0px;
    color: ${COLORS.black45};
    display: flex;

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }

    a {
      width: 100%;

      svg {
        margin-left: 6px;
        width: 12px;
        position: relative;
        top: 2px;
      }
    }

    &:last-child {
      margin-bottom: 0px;
    }
  }
`;

const ClickableArea = styled.div`
  display: flex;
  align-content: space-between;
  padding: 4px;
  font-weight: 600;
  color: ${COLORS.black85};
  background: ${COLORS.white};
  border-radius: 4px;
  word-break: break-all;

  &:hover {
    background: ${COLORS.coeblue1};
  }

  & span {
    flex: 1;
  }
`;

interface SourceInfoCardProps {
  label: string;
  link: string;
  title?: string;
}

export const SourceInfoCard = ({ label, link, title }: SourceInfoCardProps) => (
  <Card>
    <StyledPanel>
      <CardHeader icon={<Source fill={COLORS.black} />} title={title ?? "Source"} />
      <StyledList>
        <li>
          <a href={link} target="_blank">
            <ClickableArea>
              <span>{label}</span>
              <NewWindow fill={COLORS.black85} style={{ "min-width": "12px" }} />
            </ClickableArea>
          </a>
        </li>
      </StyledList>
    </StyledPanel>
  </Card>
);
